import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LoadingOverlay } from "@mantine/core";
import { findMe } from "@/services/user";

export function PublicOnly() {
  const [status, setStatus] = useState<"loading" | "authenticated" | "unauthenticated">("loading");

  useEffect(() => {
    findMe()
      .then(() => setStatus("authenticated"))
      .catch(() => setStatus("unauthenticated"));
  }, []);

  if (status === "loading") return <LoadingOverlay visible />;
  if (status === "authenticated") return <Navigate to="/dash/home" replace />;

  return <Outlet />;
}
